import React from "react"
import { Route, Switch, Redirect } from "react-router-dom"
import User from './views/User'
import Role from './views/Role'
import Operator from './views/Operator'
import Menu from './views/Menu'
import NotificationTemplate from './views/NotificationTemplate'
import SendNotification from './views/SendNotification'
import SendRecord from './views/SendRecord'
import SendingRecord from './views/SendingRecord'
import UserOperation from './views/UserOperation'
import CustomerService from './views/CustomerService'
import DeviceStatus from './views/DeviceStatus'
import DeviceStatusByIMEI from './views/DeviceStatusByIMEI'
import UploadIMEI from './views/UploadIMEI'
import TestIMEI from './views/TestIMEI'
import PasswordToDelete from './views/PasswordToDelete'
import FlexiblePackage from './views/FlexiblePackage'
import HistoryLogsByIMEI from './views/HistoryLogsByIMEI'
import SaveDevice from './views/SaveDevice'
import GetOfflineCode from './views/GetOfflineCode'

const routes = [
  {
    path: "/welcome",
    component: () => <div>R-Guard</div>
  },
  {
    path: "/user",
    component: User
  },
  {
    path: "/role",
    component: Role
  },
  {
    path: "/operator",
    component: Operator
  },
  {
    path: "/menu",
    component: Menu
  },
  {
    path: "/menu",
    component: () => <div>菜单管理</div>
  },
  {
    path: "/send_notification",
    component: SendNotification
  },
  {
    path: "/notification_template",
    component: NotificationTemplate
  },
  {
    path: "/send_record",
    component: SendRecord
  },
  {
    path: "/operation_record",
    component: SendingRecord
  },
  {
    path: "/user_operation",
    component: UserOperation
  },
  {
    path: "/customer_service",
    component: CustomerService
  },
  {
    path: "/device_status",
    component: DeviceStatus
  },
  {
    path: "/device_status_imei",
    component: DeviceStatusByIMEI
  },
  {
    path: "/save_device",
    component: SaveDevice
  },
  {
    path: "/history_logs_imei",
    component: HistoryLogsByIMEI
  },
  {
    path: "/upload_imei",
    component: UploadIMEI
  },
  {
    path: "/test_imei",
    component: TestIMEI
  },
  {
    path: "/delete_password",
    component: PasswordToDelete
  },
  {
    path: "/flexible_package",
    component: FlexiblePackage
  },
  {
    path: '/get_offline_code',
    component: GetOfflineCode
  }
]
const MyRouter = () => (
  <React.Fragment>
    <Switch>
      {routes.map((route, i) => (
        <Route path={route.path} key={i} component={route.component} />
      ))}
      <Route path="/">
        <Redirect to="/welcome" />
      </Route>
    </Switch>
  </React.Fragment>
)

export default MyRouter